<div class="modal-danger">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Confirmation</h4>
        <button type="button" class="close" (click)="cancel()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>Etes vous sur ?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cancel()">Annuler</button>
        <button type="button" class="btn btn-danger" (click)="confirm()">Valider</button>
      </div>
    </div>
</div>